export const PRIMARY_COLOR = "#6EAC24";
export const PRIMARY_COLOR_HOVER = "#849909";
export const SECONDARY_COLOR = "#731DD8";
export const SECONDARY_COLOR_HOVER = "#731DD8";
export const ERROR_COLOR = "#dc143c";
// export const VERDE = "#ADC852";
// export const BLANCO = "#FFFFFF";
// export const GRIS_CLARO = "#BDBDBD";
